/**
 * Shared data table styles for Events, Transactions, Sessions, Users tables.
 * Use this for consistent design, color, alignment, and layout across all activity tables.
 */
export const TABLE_STYLES = {
  primaryBg: '#ffffff',
  secondaryBg: '#DDE2EE',
  textPrimary: '#000000',
  textSecondary: '#666666',
  accentcolor: '#0f172a',
  borderColor: '#DDE2EE',
  headerBg: '#f3f4f6', // bg-gray-100
  headerText: '#4b5563' // gray-600
};

export default TABLE_STYLES;
